module.exports = __webpack_public_path__ + "img/win.90368f23.svg";